export default {
  apiKey: "AIzaSyD6zuJTCF6RCd1Cn2-fS_GvqKB3nTktuLU",
  authDomain: "non-zone.firebaseapp.com",
  databaseURL: "https://non-zone.firebaseio.com",
  projectId: "non-zone",
  storageBucket: "non-zone.appspot.com",
  messagingSenderId: "777225273742",
  appId: "1:777225273742:web:6210e1123744d96090a4df",
  measurementId: "G-DP5ZN76WHY"
}